import { isWindows } from '../base/environment/environment';
import { isMobileBrowser } from '../base/environment/utils';
import { getLocalDesktopTrack } from '../base/tracks/functions';
import { browser } from '../base/vietmeet-lib';
/**
 * Is the current screen sharing session audio only.
 *
 * @param {IReduxState} state - The state of the application.
 * @returns {boolean}
 */
export function isAudioOnlySharing(state) {
    return isScreenAudioShared(state) && !isScreenVideoShared(state);
}
/**
 * State of audio sharing.
 *
 * @param {IReduxState} state - The state of the application.
 * @returns {boolean}
 */
export function isScreenAudioShared(state) {
    return state['features/screen-share'].isSharingAudio;
}
/**
 * Returns the visibility of the audio only screen share button. Currently only chrome browser and electron on
 * windows supports this functionality.
 *
 * @returns {boolean}
 */
export function isScreenAudioSupported() {
    return (!isMobileBrowser() && browser.isChromiumBased()) || (browser.isElectron() && isWindows());
}
/**
 * Is any screen media currently being shared, audio or video.
 *
 * @param {IReduxState} state - The state of the application.
 * @returns {boolean}
 */
export function isScreenMediaShared(state) {
    return isScreenAudioShared(state) || isScreenVideoShared(state);
}
/**
 * Is screen sharing currently active.
 *
 * @param {IReduxState} state - The state of the application.
 * @returns {boolean}
 */
export function isScreenVideoShared(state) {
    const tracks = state['features/base/tracks'];
    const localScreenshare = getLocalDesktopTrack(tracks);
    return localScreenshare?.vietmeetTrack && !localScreenshare.vietmeetTrack.isMuted();
}
